import { styled } from '@visualfabriq/vf-ui-kit';

export const PageWrapper = styled('div', ({ $theme }) => ({
  padding: `0 ${$theme.sizing.scale1000}`,
  height: `calc(100vh - 133px)`,
}));
